import { render, staticRenderFns } from "./DayTemplateCreationButton.vue?vue&type=template&id=452f117e&scoped=true&"
import script from "./DayTemplateCreationButton.vue?vue&type=script&lang=js&"
export * from "./DayTemplateCreationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f117e",
  null
  
)

export default component.exports